export default __webpack_public_path__ + "static/media/Hyperaktivität.aee212ba.gif";